module.exports = __webpack_public_path__ + "wj51c-3d-printer.png?23c6a0bad3c32cfe797eba1ad62fb4ee";